export default __webpack_public_path__ + "media/color/qtum-68bd4fce.svg";